import { type PropsWithChildren, useLayoutEffect } from "react";

interface ThemeProviderProps extends PropsWithChildren {
  theme?: "quiz" | "flow5gl";
}

export const ThemeProvider = ({ children, theme }: ThemeProviderProps) => {
  useLayoutEffect(() => {
    if (!theme) return;

    document.documentElement.classList.add(theme);
    return () => {
      document.documentElement.classList.remove(theme);
    };
  }, [theme]);

  return children;
};
